import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Col, Row, Form } from '@themesberg/react-bootstrap';
import axios from "axios";
import { API_URL, END_POINT_SUB_INDUSTRIES } from "../const";
import { showErrorToast, showSuccessToast } from "../utils/toast";
import EditFormLayout from "../components/EditFormLayout";
import EditFormActions from "../components/EditFormActions";

export const EditSubIndustryForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subIndustry, setSubIndustry] = useState(null);
  const [loading, setLoading] = useState(true);

  const rawToken = sessionStorage.getItem('quotetoken');
  const token = rawToken?.replace(/^"|"$/g, '');

  useEffect(() => {
    const fetchSubIndustryDetails = async () => {
      try {
        const response = await axios.get(`${API_URL + END_POINT_SUB_INDUSTRIES}/${id}`, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });
        setSubIndustry(response.data.data);
      } catch (error) {
        console.error('Error fetching sub industry:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubIndustryDetails();
  }, [id, token]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: subIndustry?.name || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Sub Industry name is required"),
    }),
    onSubmit: async (values) => {
      try {
        const response = await axios.put(`${API_URL + END_POINT_SUB_INDUSTRIES}/${id}`, values, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }
        });
        showSuccessToast(response.data.message)
        navigate('/industries');
      } catch (error) {
        showErrorToast(error.response?.data?.message || 'Failed to update Sub Industry.')
      }
    }
  });

  return (
    <EditFormLayout
      title="Edit Sub Industry"
      subtitle="Update sub industry details"
      backTo="/industries"
      loading={loading}
    >
      <Form noValidate onSubmit={formik.handleSubmit}>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group controlId="name">
              <Form.Label>Sub Industry Name <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                {...formik.getFieldProps("name")}
                isInvalid={formik.touched.name && formik.errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <EditFormActions
          backTo="/industries"
          isDirty={formik.dirty}
          saveDisabled={!(formik.dirty && formik.isValid)}
        />
      </Form>
    </EditFormLayout>
  );
};
